import { axios } from "../config/axios";

const endPoint = '/project/drive';

const createDrive = async (body) => {
    return axios.post(`${endPoint}`, body);
}

const getAll = async () => {
    return axios.get(`${endPoint}`);
}

const getById = async (driveId) => {
    return axios.get(`${endPoint}/${driveId}`);
}

export {
    createDrive,
    getAll,
    getById,
}